
import store from "@/store";
import PriceListsModule from "@/store/modules/PriceLists";
import Vue from "vue";
import Component from 'vue-class-component';
import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

const priceListsModule = getModule(PriceListsModule, store);

@Component
export default class SavedPricelists extends Vue {
    @Prop({
        type: Boolean,
        required: true,
    })
    value!: boolean;

    @Watch('value')
    async onVisibilityChange(v: boolean) {
        if (v) {
            await priceListsModule.fetchPriceLists();
        }
    }

    get priceLists() {
        return priceListsModule.priceListList;
    }

    clone(id: string) {
        priceListsModule.clonePriceList(id);
    }

    deletePriceList(id: string) {
        priceListsModule.deletePriceList(id);
    }
}
